import { AnyAction, ThunkAction } from "@reduxjs/toolkit";
import {
  factorsObj,
  WinFactorsModel,
  WPFProjectModel,
} from "../../models/WinProbabilityFactorModel";
import WPFSlice from "../slices/WinProbabilityFactorSlice";
import WPFService from "../../services/WinProbabilityFactorService";
import { RootState } from "../store";

export const WPFActions = WPFSlice.actions;

export const fetchQuestions = (): ThunkAction<
  void,
  RootState,
  unknown,
  AnyAction
> => {
  return async (dispatch, getState) => {
    if (getState().wpf.questions.goFactorQuestions.length === 0) {
      const response: WinFactorsModel =
        await WPFService.getWinFactorQuestions();
      dispatch(WPFActions.setQuestions(response));
    }
  };
};

export const setGoFactors = (
  factors: factorsObj
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(WPFActions.setGoFactors(factors));
  };
};

export const setGetFactors = (
  factors: factorsObj
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(WPFActions.setGetFactors(factors));
  };
};

export const fetchProjectQuestions = (
  projectId: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch, getState) => {
    // if (getState().wpf.projectQuestions.goFactorSelectedOptions.length === 0) {
    const response: WPFProjectModel =
      await WPFService.getProjectWinFactorQuestions(projectId);
    dispatch(WPFActions.setProjectQuestions(response));
    // }
  };
};
